import { ProductSizeItem } from 'src/api/types';

export enum PublishType {
  PRODUCT = 'PRODUCT',
  PRICING = 'PRICING',
  PRODUCT_AND_PRICING = 'PRODUCT_AND_PRICING',
}

export interface IPublishFormValues {
  type: PublishType;
  venues: string[];
  priceSchemeId: string | null;
  excludedItems: ProductSizeItem[];
  publicationDate: Date | null;
}

export enum Steps {
  type = 0,
  scheme = 1,
  venues = 2,
  category = 3,
  excludeProducts = 4,
  schedule = 5,
  summary = 6,
}
